import type { Meeting } from "@platform/types/platform.types";

/**
 * Return type for useUserMeetings hook.
 */
export type UseUserMeetingsResult = {
  /** List of user's meetings */
  meetings: Meeting[];
  /** Whether meetings are currently loading */
  isLoading: boolean;
};

/**
 * Hook to fetch meetings for the current user.
 *
 * TODO: Implement when meetings API endpoint is created.
 * This hook should:
 * 1. Fetch meetings from the API (e.g., GET /api/meetings/user/)
 * 2. Sort meetings by start_time
 * 3. Optionally filter by meeting type (standalone vs regular)
 *
 * @example
 * ```typescript
 * const { meetings, isLoading } = useUserMeetings();
 *
 * if (isLoading) return <Loader />;
 *
 * return (
 *   <MeetingList meetings={meetings} />
 * );
 * ```
 */
export function useUserMeetings(): UseUserMeetingsResult {
  // TODO: Replace with actual API call when meetings endpoint is implemented
  // const user = usePlatformStore((s) => s.user);
  // const { data, isLoading } = useFetchUserMeetings({ user });

  return {
    meetings: [],
    isLoading: false,
  };
}

export default useUserMeetings;
